export enum PartnerScenarioTypes {
  NONE = 'None',
  AUTO = 'Auto',
  MAIL = 'Mail',
  MANUAL = 'Manual',
  WEBPORTAL = 'WebPortal',
  REVERS = 'Revers',
}
